<template>
  <div>
    <ul class="list-padded" v-if="contact.calls.length > 0">
      <li v-for="(call, i) in contact.calls" v-bind:key="i">
        <div>
          <strong>{{ call.outcome }}</strong>
        </div>
        <div>{{ call.note && call.note.note }}</div>
        <div class="text-muted">
          <small>
            <em>{{ call.date | dateTimeString }}</em>
            &nbsp;|&nbsp;
            <em><a @click="editCall(call.id)">Edit</a></em>
            &nbsp;|&nbsp;
            <em><a class="text-danger" @click="deleteCall(call.id)">Delete</a></em>
          </small>
        </div>
      </li>
    </ul>
    <log-call-modal :call-id="editCallId" :contact="contact" ref="logCallModal" v-if="contact && editCallId" />
  </div>
</template>

<script>
import ContactsService from '../../services/ContactsService'
import LogCallModal from '../LogCall/LogCallModal'
import { EventBus } from '../../events'

export default {
  components: {
    LogCallModal
  },
  props: {
    contact: {}
  },
  data () {
    return {
      editCallId: null
    }
  },
  methods: {
    async deleteCall (callId) {
      if (!confirm('Are you sure that you want to delete this note?')) {
        return
      }
      try {
        await ContactsService.deleteCall(this.contact.id, callId)
      } catch (e) {
        this.addNoteSubmitError = e
      }
    },
    async editCall (callId) {
      // open the log call modal
      EventBus.$emit('logCallModalEditCall', callId)
    }
  }
}
</script>
